export const TARIFF_TEXTS = {
  archive: {
    tag: 'тариф устарел',
    title: 'ваш тариф можно улучшить',
    description:
      'в новых тарифах UP легко настроить количество гб и минут, и не платить за лишнее — а ещё',
    options: [
      'бесконечный трафик на популярные сервисы',
      'тариф можно разделить с близкими и настроить общий баланс',
    ],
    btnText: 'настроить тариф',
  },
  manage: {
    btnTitle: 'настроить тариф',
  },
  error: 'нажмите, чтобы обновить',
  billingText: 'спишется',
};
